import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  "data-name": "レイヤー 2",
  viewBox: "0 0 24 24"
}
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<defs><clipPath id=\"a\"><circle cx=\"12\" cy=\"12\" r=\"12\" class=\"cls-1\"></circle></clipPath></defs><g data-name=\"レイヤー 1\" style=\"clip-path:url(#a);fill:none;stroke:#fff;stroke-width:1.4px;\"><circle cx=\"11.999\" cy=\"8\" r=\"4\" class=\"cls-3\" data-name=\"楕円形 371\"></circle><path d=\"M5 22.309c.028-4.4 1.916-7.964 7.049-7.944s6.977 3.6 6.951 8\" data-name=\"パス 819\" style=\"stroke-linecap:round;\"></path><circle cx=\"12\" cy=\"12\" r=\"11.2\" class=\"cls-3\"></circle><path d=\"M0 0h24v24H0z\" class=\"cls-1\"></path></g>", 2)
const _hoisted_4 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_4]))
}
export default { render: render }